import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './TextIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const TextIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function TextIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 17 16" component={Icon} {...props} />
  );
});
